import React, { useState } from "react";
import GoodCall from "./GoodCall";
import Clarity from "./Clarity";
import EmployeeFirst from "./EmployeeFirst";

import goodCallIcon from "../assets/HomePageTabs/goodcall-tab-icon.png";
import wccIcon from "../assets/HomePageTabs/wcc-tab-icon.png";
import employeeCareIcon from "../assets/HomePageTabs/employeecare-tab-icon.png";
import GoodCallPlan from "./GoodCallPlan";
import EmployeeFirstPlan from "./EmployeeFirstPlan";
import ClarityPlan from "./ClarityPlan";

const ServiceTabs = () => {
  const [activeTab, setActiveTab] = useState("goodcall");

  const renderTabContent = () => {
    switch (activeTab) {
      case "goodcall":
        return (
          <>
            {" "}
            <GoodCall />
            <GoodCallPlan />
          </>
        );
      case "Clarity":
        return (
          <>
            {" "}
            <Clarity />
            <ClarityPlan />
          </>
        );
      case "EmployeeFirst":
        return <>
        {" "}
        <EmployeeFirst />
        <EmployeeFirstPlan />
      </>;
      default:
        return null;
    }
  };

  return (
    <div className="tabs-wrapper">
      <div className="custom-tabs-nav">
        <button
          className={`custom-tab ${activeTab === "goodcall" ? "active" : ""}`}
          onClick={() => setActiveTab("goodcall")}
        >
          <img src={goodCallIcon} alt="Good Call Icon" />
          <div>
            <span className="tab-title">Good Call</span>
            <span className="tab-subtitle">friend to friend</span>
          </div>
        </button>

        <button
          className={`custom-tab ${activeTab === "Clarity" ? "active" : ""}`}
          onClick={() => setActiveTab("Clarity")}
        >
          <img src={wccIcon} alt="WCC Icon" />
          <div>
            <span className="tab-title">Clarity</span>
            <span className="tab-subtitle">counseling card</span>
          </div>
        </button>

        <button
          className={`custom-tab ${activeTab === "EmployeeFirst" ? "active" : ""}`}
          onClick={() => setActiveTab("EmployeeFirst")}
        >
          <img src={employeeCareIcon} alt="Employee Care Icon" />
          <div>
            <span className="tab-title">EmployeeFirst</span>
            <span className="tab-subtitle">Corporate Counseling</span>
          </div>
        </button>
      </div>

      <div className="tabs-content">{renderTabContent()}</div>
    </div>
  );
};

export default ServiceTabs;
